import React, { useEffect, useState } from 'react';
import Preloader from '../../Components/Preloader';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';
import { NavLink } from 'react-router-dom';
import Help_Seo from '../../SEO/Help_Seo';
import FsLightbox from 'fslightbox-react';
import AOS from 'aos';

function Help() {
    const [isLoading, setIsLoading] = useState(true);
    const [lightboxController, setLightboxController] = useState({
        toggler: false,
        source: '',
    });

    useEffect(() => {
        // Simulate an asynchronous operation (e.g., fetching data)
        setTimeout(() => {
            setIsLoading(false);
        }, 500); // Simulating a 1-second delay
    }, []);

    const openVideoPopup = (videoUrl) => {
        setLightboxController({
            toggler: !lightboxController.toggler,
            source: videoUrl,
        });
    };
    useEffect(() => {
        AOS.init({
            duration: 3000,
            easing: 'ease-in-out',
            once: true,
            mirror: false,
        });
    }, []);

    return (
        <>
            {isLoading ? (
                <Preloader />
            ) : (
                <>
                    <Help_Seo />
                    <Header />
                    {/* Internal CSS */}
                    <style>
                        {`
                            .help-section-wrap {
                                padding: 100px 0;
                                background:
                                    radial-gradient(1000px 500px at -10% 0%, rgba(124,77,255,0.08), transparent 60%),
                                    radial-gradient(800px 400px at 110% 100%, rgba(111,66,193,0.07), transparent 60%),
                                    linear-gradient(180deg, #fbfaff 0%, #ffffff 100%);
                            }
                            .help-section-block { margin-bottom: 64px; }
                            .help-section-block:last-child { margin-bottom: 0; }
                            .help-heading-row {
                                display: flex;
                                align-items: flex-end;
                                justify-content: space-between;
                                gap: 16px;
                                margin-bottom: 28px;
                            }
                            .help-heading-row .help-eyebrow {
                                display: inline-flex;
                                align-items: center;
                                gap: 10px;
                                font-size: 12px;
                                font-weight: 700;
                                letter-spacing: 2px;
                                text-transform: uppercase;
                                color: #6f42c1;
                                margin-bottom: 10px;
                                padding: 6px 14px;
                                background: #efe7ff;
                                border-radius: 999px;
                            }
                            .help-heading-row .help-eyebrow::before {
                                content: '';
                                width: 6px; height: 6px; border-radius: 50%;
                                background: #6f42c1;
                            }
                            .help-heading-row h3 {
                                margin: 0;
                                font-size: 26px;
                                font-weight: 800;
                                color: #111128;
                                letter-spacing: -0.3px;
                            }
                            .help-heading-row .help-heading-sub {
                                color: #6b6b85;
                                font-size: 14px;
                                margin-top: 4px;
                            }
                            .help-card {
                                position: relative;
                                display: flex;
                                align-items: center;
                                gap: 20px;
                                padding: 26px 28px;
                                background: #ffffff;
                                border: 1px solid #ececf5;
                                border-radius: 22px;
                                box-shadow: 0 10px 30px rgba(111, 66, 193, 0.06);
                                transition: all 0.35s ease;
                                overflow: hidden;
                                min-height: 120px;
                                height: 100%;
                                isolation: isolate;
                            }
                            .help-card::before {
                                content: '';
                                position: absolute;
                                top: -60px; right: -60px;
                                width: 160px; height: 160px;
                                border-radius: 50%;
                                background: radial-gradient(circle, rgba(124,77,255,0.18) 0%, rgba(124,77,255,0) 70%);
                                z-index: -1;
                                transition: transform 0.4s ease;
                            }
                            .help-card:hover {
                                transform: translateY(-4px);
                                box-shadow: 0 20px 44px rgba(111, 66, 193, 0.16);
                                border-color: #d9ccff;
                            }
                            .help-card:hover::before { transform: scale(1.3); }
                            .help-card .help-icon {
                                flex: 0 0 auto;
                                width: 62px; height: 62px;
                                border-radius: 16px;
                                background: linear-gradient(135deg, #8a63ff, #6f42c1);
                                display: flex; align-items: center; justify-content: center;
                                box-shadow: 0 10px 22px rgba(111, 66, 193, 0.32), inset 0 1px 0 rgba(255,255,255,0.3);
                                position: relative;
                            }
                            .help-card .help-icon::after {
                                content: '';
                                position: absolute;
                                inset: 0;
                                border-radius: 16px;
                                background: linear-gradient(135deg, rgba(255,255,255,0.25), transparent 60%);
                                pointer-events: none;
                            }
                            .help-card .help-icon img { width: 30px; height: 30px; filter: brightness(0) invert(1); position: relative; z-index: 1; }
                            .help-card .help-text { flex: 1 1 auto; min-width: 0; }
                            .help-card .help-text h5 {
                                margin: 0;
                                font-size: 17px;
                                font-weight: 700;
                                color: #111128;
                                line-height: 1.3;
                            }
                            .help-card .help-text h5 a,
                            .help-card .help-text h5 span { color: inherit; text-decoration: none; }
                            .help-card:hover .help-text h5 { color: #6f42c1; }
                            .help-card .help-sub {
                                display: block;
                                margin-top: 6px;
                                font-size: 13.5px;
                                font-weight: 500;
                                color: #7a7a95;
                                line-height: 1.5;
                            }
                            .help-card .help-arrow {
                                width: 40px; height: 40px; border-radius: 50%;
                                background: #f4efff; color: #6f42c1;
                                display: flex; align-items: center; justify-content: center;
                                transition: all 0.3s ease;
                                flex: 0 0 auto;
                                font-size: 14px;
                            }
                            .help-card:hover .help-arrow {
                                background: linear-gradient(135deg, #8a63ff, #6f42c1);
                                color: #fff;
                                transform: translateX(4px);
                                box-shadow: 0 8px 20px rgba(111, 66, 193, 0.35);
                            }
                            .help-card .video-play-btn {
                                width: 46px; height: 46px;
                                border-radius: 50%;
                                background: linear-gradient(135deg, #8a63ff, #6f42c1);
                                color: #fff;
                                border: none;
                                display: flex; align-items: center; justify-content: center;
                                box-shadow: 0 10px 22px rgba(111, 66, 193, 0.38);
                                cursor: pointer;
                                transition: transform 0.3s ease;
                                flex: 0 0 auto;
                                font-size: 13px;
                                position: relative;
                            }
                            .help-card .video-play-btn::before {
                                content: '';
                                position: absolute;
                                inset: -6px;
                                border-radius: 50%;
                                border: 2px solid rgba(111, 66, 193, 0.25);
                                animation: helpPulse 2s ease-out infinite;
                            }
                            @keyframes helpPulse {
                                0% { transform: scale(0.9); opacity: 0.9; }
                                100% { transform: scale(1.35); opacity: 0; }
                            }
                            .help-card .video-play-btn:hover { transform: scale(1.08); }
                            .help-card-link { display: block; height: 100%; }
                            .help-card-link, .help-card-link:hover { text-decoration: none; }
                            @media (max-width: 767px) {
                                .help-section-wrap { padding: 60px 0; }
                                .help-section-block { margin-bottom: 44px; }
                                .help-heading-row h3 { font-size: 22px; }
                                .help-card { padding: 20px; gap: 16px; min-height: 104px; }
                                .help-card .help-icon { width: 54px; height: 54px; }
                            }
                        `}
                    </style>
                    {/* Start Page Banner Area */}
                    <div className="page-banner-area position-relative overflow-hidden" style={{ backgroundImage: 'url(assets/images/hero/hero-image-2.svg)' }}>
                        <div className="container">
                            <div className="page-banner-content">
                                <h1>Help</h1>
                                <ul>
                                    <li><NavLink to="/">Home</NavLink></li>
                                    <li>Help</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    {/* End Page Banner Area */}
                    {/* Help section start */}
                    <div className="help-section-wrap">
                        <div className="container">
                            {/* For Documents */}
                            <div className="help-section-block" data-aos="fade-up">
                                <div className="help-heading-row">
                                    <div>
                                        <span className="help-eyebrow">For documents</span>
                                        <h3>Upload and manage your documents</h3>
                                        <div className="help-heading-sub">Quick guides to help you complete verification.</div>
                                    </div>
                                </div>
                                <div className="row g-4">
                                    <div className="col-lg-6">
                                        <div className="help-card">
                                            <div className="help-icon">
                                                <img src="assets/images/photo/kyc.png" alt="KYC" />
                                            </div>
                                            <div className="help-text">
                                                <h5><NavLink to="/onboarding">KYC upload</NavLink></h5>
                                                <span className="help-sub">Step-by-step guide to completing your KYC</span>
                                            </div>
                                            <button
                                                className="video-play-btn"
                                                aria-label="Play video"
                                                onClick={() => openVideoPopup("https://www.youtube.com/watch?v=qceO0YPfcVo")}
                                            >
                                                <i className="fa-solid fa-play"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* For Safety */}
                            <div className="help-section-block" data-aos="fade-up">
                                <div className="help-heading-row">
                                    <div>
                                        <span className="help-eyebrow">For safety</span>
                                        <h3>Your data, protected by design</h3>
                                        <div className="help-heading-sub">Understand how we keep your information secure.</div>
                                    </div>
                                </div>
                                <div className="row g-4">
                                    <div className="col-lg-6">
                                        <NavLink to="/data-safety" className="help-card-link">
                                            <div className="help-card">
                                                <div className="help-icon">
                                                    <img src="assets/images/photo/data-safety.png" alt="Data Safety" />
                                                </div>
                                                <div className="help-text">
                                                    <h5><span>Data safety</span></h5>
                                                    <span className="help-sub">Learn how your data stays encrypted and private</span>
                                                </div>
                                                <span className="help-arrow"><i className="fa-solid fa-arrow-right"></i></span>
                                            </div>
                                        </NavLink>
                                    </div>
                                </div>
                            </div>

                            {/* For FAQ's */}
                            <div className="help-section-block" data-aos="fade-up">
                                <div className="help-heading-row">
                                    <div>
                                        <span className="help-eyebrow">For FAQ's</span>
                                        <h3>Answers to your questions</h3>
                                        <div className="help-heading-sub">Find quick answers on onboarding and general topics.</div>
                                    </div>
                                </div>
                                <div className="row g-4">
                                    <div className="col-lg-6">
                                        <NavLink to="/onboarding-faq" className="help-card-link">
                                            <div className="help-card">
                                                <div className="help-icon">
                                                    <img src="assets/images/photo/onbordingfaq.png" alt="Onboarding FAQ" />
                                                </div>
                                                <div className="help-text">
                                                    <h5><span>Onboarding FAQs</span></h5>
                                                    <span className="help-sub">Common questions while getting started</span>
                                                </div>
                                                <span className="help-arrow"><i className="fa-solid fa-arrow-right"></i></span>
                                            </div>
                                        </NavLink>
                                    </div>
                                    <div className="col-lg-6">
                                        <NavLink to="/general-faq" className="help-card-link">
                                            <div className="help-card">
                                                <div className="help-icon">
                                                    <img src="assets/images/photo/faq.png" alt="General FAQ" />
                                                </div>
                                                <div className="help-text">
                                                    <h5><span>General FAQs</span></h5>
                                                    <span className="help-sub">Answers to the most common queries</span>
                                                </div>
                                                <span className="help-arrow"><i className="fa-solid fa-arrow-right"></i></span>
                                            </div>
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Help section end */}
                    {/* Footer Section Here */}
                    <Footer />
                    {/* FsLightbox Component */}
                    <FsLightbox
                        toggler={lightboxController.toggler}
                        sources={[lightboxController.source]}
                    />
                </>
            )}
        </>
    );
}

export default Help;
